
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PRESIDENT = 'PRESIDENT',
  DEPUTY = 'DEPUTY',
  TENANT = 'TENANT',
  MAINTENANCE_STAFF = 'MAINTENANCE_STAFF'
}

export interface User {
  id: string;
  name: string;
  email: string;
  phone?: string;
  role: UserRole;
  apartment?: string;
  buildingId?: string;
}

export enum UnitType {
  RESIDENTIAL = 'RESIDENTIAL',
  BUSINESS = 'BUSINESS'
}

export interface UnitHistoryEntry {
  id: string;
  timestamp: string;
  changeType: 'TENANT_CHANGE' | 'OWNER_CHANGE' | 'STATUS_CHANGE' | 'CREATION';
  description: string;
  performedBy: string;
}

export interface ResidentUnit {
  id: string;
  unitNumber: string;
  floor: string;
  type: UnitType;
  isOccupied: boolean;
  isRented: boolean;
  tenantName: string;
  tenantEmail: string;
  tenantPhone: string;
  ownerName: string;
  ownerContact?: string;
  history: UnitHistoryEntry[];
}

export interface Attachment {
  url: string;
  type: 'IMAGE' | 'VIDEO' | 'DOCUMENT';
  name?: string;
}

export interface SentMessage {
  id: string;
  timestamp: string;
  subject: string;
  content: string;
  recipientsCount: number;
  recipientNames: string[];
  type: 'INDIVIDUAL' | 'GROUP' | 'ALL';
  attachments?: Attachment[];
}

export interface Building {
  id: string;
  name: string;
  address: string;
  apartmentCount: number;
  managerName?: string;
  managerEmail?: string;
}

export interface Announcement {
  id: string;
  title: string;
  content: string;
  author: string;
  date: string;
  category: 'Општо' | 'Одржување' | 'Итно' | 'Состанок';
  media?: Attachment;
}

export interface TicketHistoryEntry {
  id: string;
  timestamp: string;
  status: string;
  changedBy: string;
  comment?: string;
}

export interface MaintenanceTicket {
  id: string;
  ownerId: string;
  ownerName: string;
  apartment: string;
  issue: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'RESOLVED';
  priority: 'LOW' | 'MEDIUM' | 'HIGH';
  createdAt: string;
  dueDate: string;
  history: TicketHistoryEntry[];
}

export interface Vote {
  id: string;
  question: string;
  options: string[];
  results: Record<string, number>;
  expiresAt: string;
  votedBy: string[];
}

export interface CalendarEvent {
  id: string;
  title: string;
  date: string;
  time?: string;
  location?: string;
  type: 'СОСТАНОК' | 'ОДРЖУВАЊЕ' | 'ДРУЖЕЊЕ';
  description: string;
}

export interface MonthlyPayment {
  unitId: string;
  month: number;
  year: number;
  isPaid: boolean;
  amount: number;
  paidAt?: string;
}
